document.addEventListener("DOMContentLoaded", function () {

  const personalizeBtn = document.querySelector(".personalize-btn");
  const popup = document.querySelector(".personalization-popup");
  const closePopup = document.querySelector(".popup-close");

  const initialsInput = document.querySelector("#personalization-initials");
  const previewText = document.querySelector(".initial-preview");

  const colorOptions = document.querySelectorAll(".color-option");

  const hiddenInitials = document.querySelector("#hidden-initials");
  const hiddenColor = document.querySelector("#hidden-color");

  const saveBtn = document.querySelector(".save-personalization");

  const personalizationCheckbox = document.querySelector("#enable-personalization-charge");

  let selectedColor = "";

 // ENABLE SAVE BUTTON AFTER CHECKBOX

if (personalizationCheckbox && saveBtn) {

  saveBtn.disabled = true;

  personalizationCheckbox.addEventListener("change", function () {

    saveBtn.disabled = !this.checked;

  });

}

  if (!personalizeBtn || !popup) return;

  // OPEN POPUP
personalizeBtn.addEventListener("click", function () {

  popup.classList.add("active");

  // META PIXEL EVENT
  if (typeof fbq !== 'undefined') {
    fbq('trackCustom', 'PersonalizationPopupOpened');
  }

  // GOOGLE ANALYTICS EVENT
  if (typeof gtag !== 'undefined') {
    gtag('event', 'personalization_popup_opened');
  }

});

  // CLOSE POPUP
  function closePersonalizationPopup() {
    popup.classList.remove("active");

  }

  closePopup.addEventListener("click", closePersonalizationPopup);

  popup.addEventListener("click", function (e) {
    if (e.target === popup) {
      closePersonalizationPopup();
    }
  });

  // LIVE INITIALS
initialsInput.addEventListener("input", function () {

  let value = this.value.toUpperCase();

  // ALLOW ONLY A-Z, SPACE, DOT
  value = value.replace(/[^A-Z.\s]/g, '');

  // CHARACTER LIMIT
  value = value.substring(0, initialsInput.maxLength);

  this.value = value;

  previewText.textContent = value;

});

  // COLOR SWITCHING
colorOptions.forEach(option => {

  option.addEventListener("click", function () {

    colorOptions.forEach(opt => opt.classList.remove("active"));

    this.classList.add("active");

    selectedColor = this.dataset.color;

    hiddenColor.value = selectedColor;

    if (selectedColor === "Gold") {

      previewText.style.color = "#D4AF37";
      previewText.style.textShadow = "none";

    }

    else if (selectedColor === "Silver") {

      previewText.style.color = "#C0C0C0";
      previewText.style.textShadow = "none";

    }

    else if (selectedColor === "Blind") {

      previewText.style.color = "rgba(0,0,0,0.18)";

      previewText.style.textShadow =
        "1px 1px 1px rgba(255,255,255,0.12), -1px -1px 1px rgba(0,0,0,0.15)";

    }

  });

});

  // SAVE PERSONALIZATION
  saveBtn.addEventListener("click", function (e) {

  e.preventDefault();
  e.stopPropagation();

    hiddenInitials.value = initialsInput.value;

    hiddenColor.value = selectedColor;

    // FORCE FORM UPDATE FOR DYNAMIC CHECKOUTS

hiddenInitials.dispatchEvent(new Event('change', { bubbles: true }));

hiddenColor.dispatchEvent(new Event('change', { bubbles: true }));

const hiddenCharge = document.querySelector('#hidden-personalization-charge');

if (personalizationCheckbox && personalizationCheckbox.checked) {

  hiddenCharge.value = 'Yes';

  fetch('/cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({
    items: [
      {
        id: 44114177359960,
        quantity: 1
      }
    ]
  })
});

}
    closePersonalizationPopup();

  });

});
// VARIANT IMAGE SWITCHING

document.addEventListener("DOMContentLoaded", function () {

  const previewImage = document.querySelector("#personalization-preview-image");

  const variantDataElement = document.querySelector("#variant-personalization-data");

  if (!previewImage || !variantDataElement) return;

  const variantData = JSON.parse(variantDataElement.textContent);

  // WATCH VARIANT CHANGE
  document.addEventListener("change", function () {

    const variantIdInput = document.querySelector('input[name="id"]');

    if (!variantIdInput) return;

    const variantId = variantIdInput.value;

    if (
      variantData[variantId] &&
      variantData[variantId].image
    ) {

      previewImage.src = variantData[variantId].image;

    }

  });

});